import { Loading } from "components/shared";
import { APP_NAME } from "constants/app.constant";
import React, { createContext, useContext, useEffect, useState } from "react";
import { apiGetTenantConfigs } from "services/AuthService";
import { changeFavicon, changeTitle } from "utils/helper";
import { initiateGoogleAnalytics } from "./useGoogleAnalytics";
import { useDispatch } from "react-redux";
import { setThemeColor, setThemeColorLevel } from "store/theme/themeSlice";
import { initiateMetaPixel } from "./useMetaPixel";
import { initiateGoogleSSO } from "./useGoogleSSO";
import { initiateRespondIoWebchat } from "./useRespondIoWebchat";
import { applyBrandPalette } from "utils/brandPalette";
// import { getSystemTheme } from "./helper";
// import useDarkMode from "utils/hooks/useDarkMode";

// const LOCAL_STORAGE_KEY = "user-theme-preference";
const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  // const [isDark, setIsDark] = useDarkMode();

  // useEffect(() => {
  //   const storedTheme = localStorage.getItem(LOCAL_STORAGE_KEY);

  //   if (storedTheme === "dark" || storedTheme === "light") {
  //     setIsDark(storedTheme);
  //   } else {
  //     setIsDark(getSystemTheme());
  //   }

  //   const media = window.matchMedia("(prefers-color-scheme: dark)");
  //   const listener = (e) => {
  //     if (!localStorage.getItem(LOCAL_STORAGE_KEY)) {
  //       setIsDark(e.matches ? "dark" : "light");
  //     }
  //   };
  //   media.addEventListener("change", listener);

  //   return () => media.removeEventListener("change", listener);
  // }, []);

  // useEffect(() => {
  //   if (isDark) {
  //     localStorage.setItem(LOCAL_STORAGE_KEY, isDark);
  //   }
  // }, [isDark]);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await apiGetTenantConfigs();
        if (res.data) {
          const tenantConfig = res.data?.tenantConfig || {};
          const studentConfig = res.data?.studentThemeConfig || {};
          const integrations = res.data?.integrations || [];

          changeTitle(
            (tenantConfig?.companyName || APP_NAME) + " - Student Portal",
          );
          changeFavicon(tenantConfig?.faviconUrl);
          setConfig({ ...tenantConfig, ...studentConfig, ...integrations });

          //theme
          dispatch(setThemeColor(studentConfig?.themeColor || "blue"));
          dispatch(
            setThemeColorLevel(
              parseInt(studentConfig?.primaryColorLevel || 600),
            ),
          );
          applyBrandPalette(
            studentConfig?.themeColor || "blue",
            parseInt(studentConfig?.primaryColorLevel || 600),
          );

          //integrations
          //ga
          const ga = integrations.find(
            (integration) => integration.integrationKey === "google-analytics",
          );
          initiateGoogleAnalytics(ga);

          // meta pixel
          const mp = integrations.find(
            (integration) => integration.integrationKey === "meta-pixel",
          );
          initiateMetaPixel(mp);

          const googleSSO = integrations.find(
            (integration) => integration.integrationKey === "google-sso",
          );
          initiateGoogleSSO(googleSSO);

          const respondIo = integrations.find(
            (integration) => integration.integrationKey === "respond-io",
          );
          initiateRespondIoWebchat(respondIo);
        } else {
          setConfig({});
        }
      } catch (err) {
        console.error("Failed to load tenant config", err);
        setConfig({});
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  if (loading) {
    return (
      <div className="w-full h-screen flex justify-center items-center bg-white dark:bg-gray-800">
        <Loading loading={true} />
      </div>
    );
  }

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};

// Custom hook
export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context;
};
